import { useTranslation } from 'react-i18next'
import React, { useMemo } from 'react'

import { useSegmentationForm, useSegmentationFormActions } from '../_form/SegmentationFormHandler'
import PlaceLevelsCardPicker from '../../../../containers/places/placeLevelsSelect/cardPicker/PlaceLevelsCardPicker'

export const usePlaceLevelStepDef = () => {
  const { t } = useTranslation('editSegmentation')
  const form = useSegmentationForm()

  return useMemo(
    () => ({
      title: t('placeLevelStep.title'),
      subtitle: t('placeLevelStep.subtitle'),
      Component: PlaceLevelStep,
      validate: () => {
        if (!form.placeLevels.length) return [false, t('placeLevelStep.selectPlaceRequired')]
        return [true]
      }
    }),
    [form.placeLevels, form.userGroups, t]
  )
}

const PlaceLevelStep = () => {
  const form = useSegmentationForm()
  const { handleChange } = useSegmentationFormActions()

  return (
    <PlaceLevelsCardPicker
      idField="id"
      value={form.placeLevels}
      onChange={handleChange('placeLevels')}
      multiple
      useSelectAll
    />
  )
}

export default PlaceLevelStep
